import React, { useEffect } from 'react';

const DiamondBackground = () => {
  useEffect(() => {
    const body = document.body;
    const diamondsCount = 15;

    const existingDiamonds = document.querySelectorAll('.diamond');
    existingDiamonds.forEach(diamond => diamond.remove());

    for (let i = 0; i < diamondsCount; i++) {
      const diamond = document.createElement('div');
      diamond.classList.add('diamond');
      diamond.style.left = Math.random() * 100 + 'vw';
      diamond.style.top = Math.random() * 100 + 'vh';
      diamond.style.animationDelay = Math.random() * 5 + 's';
      body.appendChild(diamond);
    }

    return () => {
    };
  }, []);

  return null;
};

export default DiamondBackground;